import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { text_kit, voucher_overview_box } from 'src/types'
import { fill_placeholders } from 'src/utils'

export const OverviewBox: FC<voucher_overview_box> = ({
  n_voucher,
  types,
  on_filter,
}: voucher_overview_box) => {
  const { t } = useTranslation()

  /**
   * Use State
   */
  const [selected_item, set_selected_item] = useState({ type: 'all-types' })

  /**
   * Use Effect
   */
  useEffect(() => {
    on_filter(selected_item)
  }, [selected_item])

  /**
   * Render functions
   */
  const render_items = () => (
    <div>
      {render_item({
        key: 'all-types',
        value: fill_placeholders(t('community.all_categories'), [String(n_voucher || '')]),
      })}
      {Object.entries(types || {}).map(([key, value]) => {
        return render_item({
          key,
          value: key ? `${key} (${value})` : '',
        })
      })}
    </div>
  )

  const render_item = (item: text_kit) => {
    const highlight = item?.key === selected_item?.type
    const font = highlight ? 'font-18-semibold c-159881' : 'font-18 c-00000080'
    return (
      <p
        key={item?.key}
        className={`mb-3 p-0 mt-2 width-fit-content ${font}`}
        role="button"
        onClick={() => {
          set_selected_item({ ...selected_item, type: item?.key || '' })
        }}
      >
        {item?.value}
      </p>
    )
  }

  return (
    <main>
      <div className="font-30-freightdisp-semibold mb-3">{t('community.benefit_title')}</div>
      <p className="font-18 c-00000080 mb-4">{t('community.benefit_subtitle')}</p>
      {Object.keys(types || {})?.length > 1 && (
        <div>
          <p className="p-0 mb-3 font-14-semibold text-uppercase">{t('community.categories')}</p>
          {render_items()}
        </div>
      )}
    </main>
  )
}
